import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email_register: '',
};

export const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    setEmailRegister: (state, action) => {
      state.email_register = action.payload;
    },
  },
});

export const { setEmailRegister } = registerSlice.actions;

export const selectEmailRegister = (state) => state.register.email_register;

export default registerSlice.reducer;
